import { render, staticRenderFns } from "./lkuPinjamanSimple.vue?vue&type=template&id=2f79979a&"
import script from "./lkuPinjamanSimple.vue?vue&type=script&lang=js&"
export * from "./lkuPinjamanSimple.vue?vue&type=script&lang=js&"
import style0 from "./lkuPinjamanSimple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports